<div #confirmPrepareTaxReturnModal class="ui modal confirm-prepare">
  <div class="modal-close close icon"></div>

  <h1>{{ "are-you-sure" | transloco }}</h1>

  {{ assignedUser?.name }} is already preparing this return. If you proceed, you
  will be assigned as the preparer of this return instead.

  <div class="actions">
    <span class="go-back cancel">{{ "no-cancel" | transloco }}</span>
    <div
      class="ui primary background button approve"
      [ngClass]="{ disabled: actioning }"
    >
      {{ "yes-prepare-return" | transloco }}
    </div>
  </div>
</div>

<div #confirmReviewTaxReturnModal class="ui modal confirm-review">
  <div class="modal-close close icon"></div>

  <h1>{{ "are-you-sure" | transloco }}</h1>

  <div class="content">
    {{ assignedUser?.name }} is already reviewing this {{ taxReturnAlias }} as
    the {{ reviewOrdinal }} reviewer. If you proceed, you will be assigned as
    the {{ reviewOrdinal }} reviewer of this return instead.
  </div>

  <div class="actions">
    <span class="go-back cancel">{{ "no-cancel" | transloco }}</span>
    <div
      class="ui primary background button approve"
      [ngClass]="{ disabled: actioning }"
    >
      {{ "yes-review-return" | transloco }}
    </div>
  </div>
</div>

<div #prefillResultsModal id="prefill-results-modal" class="ui tiny modal">
  <div class="modal-close close icon"></div>

  <h1>{{ "check-prefill-and-run-cals" | transloco }}</h1>

  <div class="content">
    @for (line of prefillResultsSummary; track line) {
    <p>
      {{ line }}
    </p>
    }
  </div>

  <div class="actions">
    <div class="ui primary background button approve">
      {{ "ok" | transloco }}
    </div>
  </div>
</div>

<div #confirmUploadLinkManuallyModal class="ui modal confirm-upload-link">
  <div class="modal-close close icon"></div>

  <h1>Confirmation</h1>

  <div class="content">
    The Taxpayer package shoud have been uploaded manually to LINK already.
    Please confirm that you have done this before transitioning to the next
    status.
  </div>

  <div class="actions">
    <span class="go-back cancel">Cancel</span>
    <div
      class="ui primary background button approve"
      [ngClass]="{ disabled: actioning }"
    >
      Confirm
    </div>
  </div>
</div>

<div #createTaxReturnModal class="ui modal create-tax-return">
  <div class="modal-close close icon"></div>

  <h1>{{ 'create-tax-return-alias' | transloco: {taxReturnAlias} }}</h1>

  <div class="content">
    {{ 'enter-the-aps' | transloco: {taxReturnAlias} }}
    <input
      id="aps-Id"
      class="aps-tax-return-id"
      [(ngModel)]="apsTaxReturnId"
      placeholder="Enter APS {{ taxReturnAlias }} ID here"
    />
  </div>

  <div class="actions">
    <span class="go-back cancel">{{ "cancel" | transloco }}</span>
    <div
      [attr.data-test-ref]="'create-tax-return-button'"
      class="ui primary background button approve"
      [ngClass]="{ disabled: actioning || !apsTaxReturnId }"
    >
      {{ "create" | transloco }}
    </div>
  </div>
</div>

<div #wrongPermissionModal class="ui modal wrong-permission">
  <div class="modal-close close icon"></div>

  <h1>{{ "wrong-permission" | transloco }}</h1>

  <div class="content">
    @if (wrongPermissionYouWerePreparer) {
    {{
      "oops-if-you-prepared-a-return-at-any-stage-you-cannot-review-it-yourself-someone-who-did-not-prepare-this-return-must-review-it"
        | transloco
    }}
    } @if (!wrongPermissionYouWerePreparer) {
    {{
      "oops-if-you-reviewed-a-return-at-any-stage-you-cannot-prepare-it-yourself-someone-who-did-not-review-this-return-must-prepare-it"
        | transloco
    }}
    }
  </div>

  <div class="actions">
    <div class="ui primary background button approve">
      {{ "okay" | transloco }}
    </div>
  </div>
</div>

<div
  #actionConfirmationModal
  class="ui modal action-confirmation"
  id="action-confirmation"
>
  <div class="modal-close close icon"></div>

  <h1>{{ "confirmation" | transloco }}</h1>

  <div class="content">
    {{ actionConfirmationText }}
  </div>

  <div class="actions">
    <span class="go-back cancel">{{ "cancel" | transloco }}</span>
    <div
      class="ui primary background button approve"
      [ngClass]="{ disabled: actioning, loading: actioning }"
    >
      {{ "yes" | transloco }}
    </div>
  </div>
</div>

<div
  #actionGenerateTaxReturnModal
  class="ui tiny modal"
  id="generate-result-modal"
>
  <div class="modal-close close icon"></div>

  <h1>{{ "tax-package-generation" | transloco }}</h1>

  @if (generatePackageResult) {
  <div class="content">
    @for (message of generatePackageResult.messages; track message) {
    <div>
      {{ message }}
    </div>
    }
    <ul>
      @for (f of generatePackageResult.forms; track f) {
      <li>
        {{ f.name }}
        @if (f.success) {
        <span class="green">&#10003;</span>
        } @if (!f.success) {
        <span class="red">&#10008;</span>
        }
      </li>
      }
    </ul>
  </div>
  }

  <div class="actions">
    <div class="ui primary background button approve">
      {{ "ok" | transloco }}
    </div>
  </div>
</div>

<div #actionSuccessModal class="ui modal action-success" id="action-success">
  <div class="modal-close close icon"></div>

  <div class="content">
    <div class="icon green-success"></div>
    <h3>
      <span class="success-text">{{ actionSuccessText }}</span>
    </h3>
  </div>

  <div class="actions">
    <div
      class="ui primary background button approve"
      id="taxreturn-created-okay"
    >
      {{ "ok" | transloco }}
    </div>
  </div>
</div>

<div #createFinalPackageModal class="ui modal create-final-package">
  <div class="modal-close close icon"></div>

  <h1>{{ "create-final-package" | transloco }}</h1>

  <div class="content">
    @if (!finalPackagePreview) {
    <div>
      {{ "loading-final-package-preview" | transloco }}
      <div class="ui active centered inline loader"></div>
    </div>
    } @if (finalPackagePreview) {
    <div>
      <p>
        The following {{ selectedDocuments(finalPackagePreview) }} file(s) will
        be merged into the final package PDF and uploaded to LINK.<br />
        <span class="important">{{ "this-is-irreversible" | transloco }}</span>
        {{ "do-you-wish-to-continue" | transloco }}
      </p>
      <table class="ui table compact">
        <thead>
          <tr>
            <td class="selected">{{ "use" | transloco }}</td>
            <td class="order">{{ "order" | transloco }}</td>
            <td class="name">{{ "name" | transloco }}</td>
            <td class="last-updated">{{ "last-updated" | transloco }}</td>
            <td class="last-updated-by">{{ "last-updated-by" | transloco }}</td>
          </tr>
        </thead>
        <tbody>
          @for (d of finalPackagePreview.documents; track d; let i = $index) {
          <tr class="row">
            <td class="selected">
              <input type="checkbox" [(ngModel)]="d.selected" />
            </td>
            <td class="order">
              <div>
                #{{ i + 1 }}
                <i class="up" (click)="moveDocUp(finalPackagePreview, i)"
                  >&#9650;</i
                >
                <i class="down" (click)="moveDocDown(finalPackagePreview, i)"
                  >&#9660;</i
                >
              </div>
            </td>
            <td class="name">
              <a [href]="d.url" target="_blank">{{ d.name }}</a>
            </td>
            <td class="last-updated">{{ d.lastUpdated }}</td>
            <td class="last-updated-by">{{ d.lastUpdatedBy }}</td>
          </tr>
          }
        </tbody>
      </table>
      <p class="docshare-links">
        <b>{{ getFolderDisplayName }} Links:</b>
        <a target="_blank" [href]="finalPackagePreview.rootFolderUrl">{{
          "root-folder" | transloco
        }}</a>
        &nbsp;-&nbsp;
        <a target="_blank" [href]="finalPackagePreview.finalFolderUrl">{{
          "final-folder" | transloco
        }}</a>
        &nbsp;-&nbsp;
        <a target="_blank" [href]="finalPackagePreview.tempFilesFolderUrl">{{
          "rubix-temp-files-folder" | transloco
        }}</a>
      </p>
      @if (finalPackagePreview.tempEmail) {
      <p class="temp-email-warning">
        {{ 'there-is-no-valid-email-for-this-taxpayer-alias-in-atlas' | transloco:{taxpayerAlias} }}
      </p>
      } @if (finalPackagePreview.tempEmail || !sendConfirmationEmail) {
      <p class="temp-email-warning">
        <span class="important">{{
          "you-must-deliver-manually" | transloco
        }}</span>
      </p>
      }
    </div>
    }
  </div>

  @if (finalPackagePreview) {
  <div class="content">
    <input type="checkbox" [(ngModel)]="sendConfirmationEmail" />
    <span>{{ "send-link-confirmation-email" | transloco }}</span>
  </div>
  } @if (finalPackagePreview) {
  <div class="actions">
    <span class="go-back cancel">{{ "no-cancel" | transloco }}</span>
    <div
      class="ui primary background button approve"
      [ngClass]="{
        loading: actioning,
        disabled: actioning || selectedDocuments(finalPackagePreview) === 0
      }"
    >
      {{ "yes-create-package-and-upload-to-link" | transloco }}
    </div>
  </div>
  }
</div>

<div #createAmendmentModal class="ui modal create-amendment">
  <div class="modal-close close icon"></div>

  <h1>{{ "are-you-sure-you-want-to-create-an-amendment" | transloco }}</h1>

  <div class="content">
    {{ 'after-creating-the-amendment-in-aps-enter-the-new-tax-return-alias-id-below' | transloco: {taxReturnAlias} }}
    <input
      class="aps-tax-return-id"
      [(ngModel)]="apsTaxReturnId"
      placeholder="Enter APS {{ taxReturnAlias }} ID here"
    />
  </div>

  <div class="actions">
    <span class="go-back cancel">{{ "cancel" | transloco }}</span>
    <div
      class="ui primary background button approve"
      [ngClass]="{ disabled: actioning || !apsTaxReturnId }"
    >
      {{ "create-amendment" | transloco }}
    </div>
  </div>
</div>

<!-- Bulk action modals -->

<div #confirmBulkPrepareTaxReturnModal class="ui modal confirm-prepare">
  <div class="modal-close close icon"></div>

  <h1>{{ "are-you-sure" | transloco }}</h1>
  {{ 'please-confirm-that-you-would-like-to-proceed-and-become-the-preparer-for-all' | transloco: {taxReturnAlias} }}
  <div class="actions">
    <span class="go-back cancel">{{ "no-cancel" | transloco }}</span>
    <div
      class="ui primary background button approve"
      [ngClass]="{ disabled: false }"
    >
      {{ "yes-prepare-returns" | transloco }}
    </div>
  </div>
</div>

<div #confirmBulkReviewTaxReturnModal class="ui modal confirm-review">
  <div class="modal-close close icon"></div>

  <h1>{{ "are-you-sure" | transloco }}</h1>

  <div class="content">
    {{ 'other-users-are-already-reviewing-some-all-selected-tax-return-alias-s-if-you-proceed-you-will-be-assigned-as-the-reviewer-of-this-return-instead' | transloco: {taxReturnAlias} }}
  </div>

  <div class="actions">
    <span class="go-back cancel">{{ "no-cancel" | transloco }}</span>
    <div
      class="ui primary background button approve"
      [ngClass]="{ disabled: actioning }"
    >
      {{ "yes-review-returns" | transloco }}
    </div>
  </div>
</div>

<div
  #actionBulkConfirmationModal
  class="ui modal action-confirmation"
  id="action-confirmation"
>
  <div class="modal-close close icon"></div>

  <h1>{{ "bulk-confirmation" | transloco }}</h1>

  <div class="content">
    {{ actionConfirmationText }}
  </div>

  <div class="actions">
    <span class="go-back cancel">{{ "cancel" | transloco }}</span>
    <div
      class="ui primary background button approve"
      [ngClass]="{ disabled: actioning, loading: actioning }"
    >
      {{ "yes" | transloco }}
    </div>
  </div>
</div>

<div
  #bulkGenerateModal
  class="ui modal action-confirmation"
  id="bulk-action-confirmation"
>
  <div class="modal-close close icon"></div>

  <h1>{{ "bulk-action-not-available" | transloco }}</h1>

  <div class="content">
    {{ 'package-generation-is-only-available-from-the-tax-return-alias-list-bulk-actions-go-back-to-the-previous-page' | transloco:{taxReturnAlias} }}
  </div>

  <div class="actions">
    <span class="go-back cancel">{{ "cancel" | transloco }}</span>
  </div>
</div>

<div
  #bulkActionNotAvailableModal
  class="ui modal action-confirmation"
  id="bulk-action-not-available"
>
  <div class="modal-close close icon"></div>

  <h1>{{ "action-not-available" | transloco }}</h1>

  <div class="content">
    {{ 'this-action-is-not-available-in-bulk-this-needs-to-be-performed-from-inside-each-tax-return-alias' | transloco: {taxReturnAlias} }}
  </div>

  <div class="actions">
    <span class="go-back cancel">{{ "cancel" | transloco }}</span>
  </div>
</div>

<div
  #actionBulkGenerateTaxReturnModal
  class="ui tiny modal"
  id="generate-result-modal"
>
  <div class="modal-close close icon"></div>

  <h1>{{ "tax-package-generation" | transloco }}</h1>

  @if (generatePackageResult) {
  <div class="content">
    @for (message of generatePackageResult.messages; track message) {
    <div>
      {{ message }}
    </div>
    }
    <ul>
      @for (f of generatePackageResult.forms; track f) {
      <li>
        {{ f.name }}
        @if (f.success) {
        <span class="green">&#10003;</span>
        } @if (!f.success) {
        <span class="red">&#10008;</span>
        }
      </li>
      }
    </ul>
  </div>
  }

  <div class="actions">
    <div class="ui primary background button approve">
      {{ "ok" | transloco }}
    </div>
  </div>
</div>

<div #createBulkFinalPackageModal class="ui modal create-final-package">
  <div class="modal-close close icon"></div>

  <h1>{{ "create-final-package" | transloco }}</h1>

  <div class="content">
    {{ "bulk-send-all-of-the-final-packages" | transloco }}
  </div>

  @if (finalPackagePreview) {
  <div class="actions">
    <span class="go-back cancel">{{ "no-cancel" | transloco }}</span>
    <div
      class="ui primary background button approve"
      [ngClass]="{
        loading: actioning,
        disabled: actioning || selectedDocuments(finalPackagePreview) === 0
      }"
    >
      {{ "yes-create-packages-and-upload-to-link" | transloco }}
    </div>
  </div>
  }
</div>

<div #createBulkAmendmentModal class="ui modal create-amendment">
  <div class="modal-close close icon"></div>

  <h1>{{ "are-you-sure-you-want-to-bulk-create-an-amendment" | transloco }}</h1>

  <div class="actions">
    <span class="go-back cancel">{{ "cancel" | transloco }}</span>
    <div
      class="ui primary background button approve"
      [ngClass]="{ disabled: actioning || !apsTaxReturnId }"
    >
      {{ "create-amendment" | transloco }}
    </div>
  </div>
</div>
